import React from "react";
import useGlobals from "../../hooks/useGlobals";
import "./MpaaRatings.scss";
import cs from "classnames";
import { MpaaRatingsItem } from "./MpaaRatingsItem";

export const MpaaRatings = ({ mpaa_ratings }) => {
  const globals = useGlobals();

  const items = [{ id: "", name: "Без рейтинга" }, ...globals.mpaa_rating];

  console.log(items);

  return (
    <div className={cs("mpaa-ratings")}>
      {items.map(item => {
        return (
          <MpaaRatingsItem
            key={item.name}
            name={item.name}
            value={mpaa_ratings[item.id]}
          />
        );
      })}
    </div>
  );
};
